import { useSelector } from 'react-redux';

export const useAppTimezone = () => useSelector((state) => state?.user.appTimezone);
